var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"screen-center",class:_vm.Alert.type,staticStyle:{"z-index":"999"},attrs:{"value":_vm.Alert.isShow,"width":_vm.Alert.width,"transition":"scale-transition","elevation":"0"}},[_c('v-icon',[_vm._v(_vm._s(_vm.Alert.icon))]),_vm._v(" "+_vm._s(_vm.Alert.msg))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }